import CreateNewPassword from 'components/authentication/newPassword/CreateNewPassword';

export const NewPasswordPage = () => {
    return <CreateNewPassword />;
};
